/**
 * Created by carson on 8/26/16.
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-drop-zone-form]').each(function() {

    var $el = $(this);
    require(['js/lib/views/DropZoneForm'], function(DropZoneForm) {

      new DropZoneForm({
        el: $el
      });
    });

  });
};


